import { useEffect, useState } from 'react';
import { Grid, CircularProgress, Typography } from '@mui/material';
import { isEmpty, isArray } from 'lodash';
import StateManager from '../StateManager';
import LinkItem from './LinkItem';
import axios from 'axios';

export default function EntryLinks({ entryId, linksUpdated, actions, ...props }) {
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (!entryId) return;

    getLinks();
  }, [entryId]); // eslint-disable-line

  useEffect(() => {
    if (!linksUpdated || !entryId) return;

    getLinks();
  }, [linksUpdated]); // eslint-disable-line

  function getLinks() {
    setLoading(true);

    axios
      .get('/links/getLinksForEntry', { params: { entryId } })
      .then(({ data }) => setLinks(data))
      .catch((err) => StateManager.setAxiosErrorAlert(err))
      .finally(() => setLoading(false));
  }

  if (!entryId) return null;

  if (loading) {
    return (
      <Grid container {...props}>
        <CircularProgress />
      </Grid>
    );
  }

  if (isEmpty(links) || !isArray(links)) return null;

  return (
    <Grid container {...props}>
      <Grid container alignItems={'center'} justifyContent={'space-between'}>
        <Typography gutterBottom variant="h6">
          List of items this entry is linked to and from:
        </Typography>

        {actions}
      </Grid>
      {links.map((link) => (
        <LinkItem key={link._id} data={link} entryId={entryId} />
      ))}
    </Grid>
  );
}
